var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 45",
    style: {
      enableBackground: "new 0 0 51 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43,21.2l-6.1-6.1c-0.6-0.6-1.6-0.6-2.2,0c-0.6,0.6-0.6,1.6,0,2.2l3.5,3.5H17.8c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5 h20.4l-3.5,3.5c-0.6,0.6-0.6,1.6,0,2.2c0.6,0.6,1.6,0.6,2.2,0l6.1-6.1C43.6,22.7,43.6,21.8,43,21.2z M28.9,26.4 c-0.9,0-1.6,0.7-1.6,1.6v5.7c0,0.2-0.2,0.4-0.4,0.4H9.4C9.2,34.2,9,34,9,33.8V10.7c0-0.2,0.2-0.4,0.4-0.4h17.5 c0.2,0,0.4,0.2,0.4,0.4v5.9c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6v-5.9c0-2-1.6-3.6-3.6-3.6H9.4c-2,0-3.6,1.6-3.6,3.6v23.1 c0,2,1.6,3.6,3.6,3.6h17.5c2,0,3.6-1.6,3.6-3.6V28C30.5,27.1,29.8,26.4,28.9,26.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.bf73d4ec.svg";
export { ForwardRef as ReactComponent };